import { styled } from '../../../../../modules';

export const Row = styled.label<{ $textColor: string; $decorate?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: ${({ $textColor }) => $textColor};

    a {
        font-weight: 500;
        text-decoration: ${({ $decorate }) => $decorate ? 'underline' : 'none'};
        color: inherit;
    }
`;

export const Input = styled.input<{ $checkboxColor: string }>`
    width: 16px;
    height: 16px;
    min-width: 16px;
    margin-top: 2px;
    accent-color: ${({ $checkboxColor }) => $checkboxColor};
    cursor: pointer;
`;

export const LabelText = styled.span`
    flex: 1;
`;

export const PseudoLink = styled.span<{ $color: string }>`
    color: ${({ $color }) => $color};
    font-weight: 500;
    cursor: pointer;
`;
